import POSSelectField from '../../../POS/Fields/POSSelectField';

import { usePOSPaymentCondition } from '../../../../hooks/sale/usePOSPaymentCondition';
import POSCreditConfiguration from '../credit/POSCreditConfiguration';
import POSMultiplePaymentSection from '../multiple/POSMultiplePaymentSection';

const POSPaymentCondition = () => {
  // =====================================================
  // 🔹 Hook
  // =====================================================
  const {
    form,

    termDropdown,

    isCredit,

    isOtherCondition,

    filteredPaymentConditions,

    openMultiPaymentModal,

    handlePaymentConditionChange,

    handleTermChange,
  } = usePOSPaymentCondition();

  // =====================================================
  // 🔹 Render
  // =====================================================
  return (
    <div
      className="
        mt-5

        border-t
        border-slate-100

        pt-5

        dark:border-strokedark
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Title */}
      {/* ===================================================== */}
      <div className="mb-4">
        <h3
          className="
            text-sm
            font-semibold
            text-slate-800

            dark:text-white
          "
        >
          Condición de Pago
        </h3>

        <p
          className="
            mt-1
            text-xs
            text-slate-500

            dark:text-slate-400
          "
        >
          Configura cómo será procesado el pago de esta venta.
        </p>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Payment Condition */}
      {/* ===================================================== */}
      <div className="space-y-4">
        <POSSelectField
          label="Condición"
          name="paymentCondition"
          value={form.paymentCondition?.id || ''}
          options={filteredPaymentConditions.map((item) => ({
            value: item.id,
            label: item.name,
          }))}
          placeholder="Seleccionar condición"
          iconKey="creditCard"
          onChange={(e) => handlePaymentConditionChange(e.target.value)}
        />

        {/* ===================================================== */}
        {/* 🔹 Credit Configuration */}
        {/* ===================================================== */}
        {isCredit && (
          <POSCreditConfiguration
            paymentCondition={form.paymentCondition}
            terms={termDropdown}
            onChangeTerm={handleTermChange}
          />
        )}

        {/* ===================================================== */}
        {/* 🔹 Multiple Payments */}
        {/* ===================================================== */}
        {isOtherCondition && (
          <POSMultiplePaymentSection onOpenModal={openMultiPaymentModal} />
        )}
      </div>
    </div>
  );
};

export default POSPaymentCondition;
